import { render, staticRenderFns } from "./EditIndexingStudent.vue?vue&type=template&id=fa1fb86e&scoped=true&"
import script from "./EditIndexingStudent.vue?vue&type=script&lang=js&"
export * from "./EditIndexingStudent.vue?vue&type=script&lang=js&"
import style0 from "./EditIndexingStudent.vue?vue&type=style&index=0&id=fa1fb86e&scoped=true&lang=css&"
import style1 from "./EditIndexingStudent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1fb86e",
  null
  
)

export default component.exports